import { render, staticRenderFns } from "./EditTotp.vue?vue&type=template&id=5d2fddc4&"
import script from "./EditTotp.vue?vue&type=script&lang=js&"
export * from "./EditTotp.vue?vue&type=script&lang=js&"
import style0 from "./EditTotp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports